import parse from "html-react-parser";

const SpecsTable = props => {
    const { block } = props;
    const { data } = block;
    return (
        <div className="customContainer">
            <div className="specificationSection">

                <div className="row">
                    <div className="col s12">
                        <h2 className="cbTitle">{block.data.title? block.data.title: null}</h2>
                    </div>
                    <div className="col s12 cbDescription">
                        {block.data.description ? parse(block.data.description) : ''}
                    </div>
                </div>

                <div className="row specifications">
                    <div className="col s12">
                        <div className="contentHolder">
                            <table className="customTable">
                                <tbody>
                                    {data.specsTable? data.specsTable.map((row, i) => {
                                        return (
                                            <tr key={"parent" + i} className={row.isTitle === "1" ? "mainRow title" : "childRow"}>
                                                {Object.entries(row).map(
                                                    ([key, value], ) =>
                                                        (key === "isTitle" ? null : <td key={`${key + value + i} "child"`}>{value}</td>)
                                                )}
                                            </tr>
                                        )
                                    }): null}
                                </tbody>
                            </table>


                        </div>
                    </div>
                </div>


            </div>
        </div >
    )
};

export default SpecsTable;
